export const peopleTableColumns = [
    {
        key: 'firstName',
        label: 'First Name.',
        sortable: true,
    },
    {
        key: 'lastName',
        label: 'Last Name',
    },
    {
        key: 'email',
        label: 'Email Address',
    },
    {
        key: 'role',
        label: 'Role',
        sortable: true,
    },
    {
        key: 'invitationStatus',
        label: 'Invitation Status',
        sortable: true,
    },
    {
        key: 'actions',
        label: '',
    },
]
